__turbopack_context__.v({
  "root": "index-module__R5JnlG__root",
});
